import { RequestOptions } from './request-options';

export class RecipeRequest extends RequestOptions {
    Id_Session: string;
    CalculationWeight: number;
    CalorificValue: number;
    Carbohydrates: number;
    CategoryName: string;
    Description: string;
    Fats: number;
    FavoriteComment: string;
    FullCategory: string;
    FullName: string;
    Id_Category: number;
    Id_Owner: number;
    Id_Recipe: number;
    Image: string;
    ImagePath: string;
    IsOwn: boolean;
    IsUsed: boolean;
    IsXcluded: boolean;
    MPek: boolean;
    Micro: boolean;
    Multi: boolean;
    Proteins: number;
    RatingFavorite: number;
    RatingMenu: number;
    RecipeGroup: string;
    Simple: number;
    Source: string;
    SubCategoryName: string;
    TimeFrom: string;
    TimeLastModifed: string;
    XcludedComment: string;
    Quality: number;
    StateForChange: number;
    IngredientsWeight: number;

}


// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-request.ts